import { MatDialog } from '@angular/material/dialog';
import { OkDialogComponent } from '../dialogs/ok-dialog/ok-dialog.component';
import { YesNoDialogComponent } from '../dialogs/yes-no-dialog/yes-no-dialog.component';
import { Injectable } from '@angular/core';

@Injectable()
export class DialogService {

    constructor(private dialog: MatDialog) { }

    openOkDialog(header: string, message: string) {
        return this.dialog.open(OkDialogComponent, {
            data: { header: header, message: message }
        });
    }

    async openYesNoDialog(header: string, message: string) {
        return await this.dialog.open(YesNoDialogComponent, {
            data: { header: header, message: message }
        }).afterClosed().toPromise().then(response => { return response });
    }
}